const theme = {
  TInput: {
    fixedClasses:
      'text-16 font-regular px-18 py-12 leading-none rounded-DEFAULT border-1 border-solid h-46 w-full',
    variants: {
      error: 'bg-brand_light-secondary border-error-primary',
      main: 'bg-gray_light-primary border-gray_dark-primary',
    },
  },
  TButton: {
    fixedClasses: 'text-14 rounded focus:outline-none',
    variants: {
      main: 'text-white-100 bg-red-100 hover:bg-red-200 w-full',
      black: 'text-white-100 bg-black-100 hover:bg-black-200 w-full',
      mainWhite: 'text-black-100 bg-white-100 hover:bg-gray-100 w-full',
      ghost:
        'text-red-100 border-1 border-solid border-red-500 hover:border-red-100 w-full',
      ghostBlack:
        'text-black-100 border-1 border-solid border-gray-400 hover:border-red-100 hover:text-red-100 w-full',
      ghostRed:
        'text-red-100 border-1 border-solid border-red-100 hover:text-red-200 hover:border-red-200 w-full bg-transparent',
      disable: 'text-white-100 bg-gray-300 w-full cursor-not-allowed',
      disableGhost:
        'text-gray-300 border-1 border-solid border-gray-300 w-full cursor-not-allowed',
    },
  },
  TCheckbox: {
    fixedClasses:
      'form-checkbox transition duration-150 ease-in-out bg-transparent',
    variants: {
      red: 'text-red-100 border-red-100',
    },
  },
  TDropdown: {
    fixedClasses: { dropdown: 'shadow-none' },
  },
  TTable: {
    classes: {
      table: 'min-w-full divide-y divide-gray-100 border-red-100 border',
      thead: '',
      theadTr: '',
      theadTh:
        'px-3 py-2 font-semibold text-left bg-white-100 border-b border-1',
      tbody: 'bg-white divide-y divide-gray-100',
      tr: '',
      td: 'px-3 py-2 whitespace-no-wrap border-b border-1 border-gray-300',
      tfoot: '',
      tfootTr: '',
      tfootTd: '',
    },
  },
  TRadio: {
    fixedClasses:
      'text-red-100 border-gray-300 focus:outline-none focus:border-red-100 focus:ring-0 focus:ring-opacity-0 focus:ring-offset-0',
  },
};

const mainTheme = {
  ...theme,
};

export default mainTheme;
